/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Period_All_TimeInputs */

const en_directory_vibebids_period_all_time = /** @type {(inputs: Directory_Vibebids_Period_All_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All-time`)
};

const zh_directory_vibebids_period_all_time = /** @type {(inputs: Directory_Vibebids_Period_All_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部时间`)
};

/**
* | output |
* | --- |
* | "All-time" |
*
* @param {Directory_Vibebids_Period_All_TimeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_period_all_time = /** @type {((inputs?: Directory_Vibebids_Period_All_TimeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Period_All_TimeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_period_all_time(inputs)
	return zh_directory_vibebids_period_all_time(inputs)
});
export { directory_vibebids_period_all_time as "directory.vibebids.period_all_time" }